module.exports = __webpack_public_path__ + "img/logo.e207cb8d.svg";